module.exports = __webpack_public_path__ + "img/jgdj32.29efa55f.svg";